import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid, Divider } from "@material-ui/core";

import { getConfigItemByParentId } from "store/state/configItems";
import { PER_MEASUREMENT } from "constants/configItemParents";
import SectionTitle from '../Components/SectionTitle';
import GridTextInput from "../Components/GridTextInput";
import GridRadioButtonList from "../Components/GridRadioButtonList";
import { yesNoOptions } from "./lists";
import { setConfigItemListState } from "../util";

class Reserves extends React.Component {
  state = {
    perMeasurements: []
  };

  componentDidMount() {
    this.props.getConfigItemByParentId({ id: PER_MEASUREMENT });
  }

  componentDidUpdate = () => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(PER_MEASUREMENT, "perMeasurements", this);
    }
  };

  render() {
    const {      
      loan,
      handleChange,
      handleTextChange,
      handleBooleanChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    return (
      <Fragment>
        <span id="loan_reserves">
        <Grid hidden={!isInitialized} item xs={7}>
            <SectionTitle>Reserves</SectionTitle>
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="replacement"
            label="Replacement"
            mask="currency"
            value={loan.replacement}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridRadioButtonList
            name="replacementPerId"
            label="Replacement per"
            value={loan.replacementPerId}
            onChange={handleTextChange}
            options={this.state.perMeasurements}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="repair"
            label="Repair"
            mask="currency"
            value={loan.repair}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridRadioButtonList
            name="repairPerId"
            label="Repair per"
            value={loan.repairPerId}
            onChange={handleTextChange}
            options={this.state.perMeasurements}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridRadioButtonList
            name="taxes"
            label="Taxes"
            value={loan.taxes}
            onChange={handleBooleanChange}
            options={yesNoOptions}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridRadioButtonList
            name="insurance"
            label="Insurance"
            value={loan.insurance}
            onChange={handleBooleanChange}
            options={yesNoOptions}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="tilcReserves"
            label="TI/LC Reserves"
            mask="currencynocents"
            value={loan.tilcReserves}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="capExReserves"
            label="CapEx Reserves"
            mask="currencynocents"
            value={loan.capExReserves}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        </span>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems } = state;
  return {
    loading,
    configItems
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId
    }
  )  
)(Reserves);
